import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupLocation } from '../Types';

const RESOURCE = 'locations';

interface ICreateLocation extends Omit<IUri, 'resource'> {
  body: Partial<IGroupLocation>;
  token: string;
}

interface ICreateLocationResponse extends IHttpResponse {
  body?: IGroupLocation;
}

export default ({
  body,
  token,
}: ICreateLocation): Promise<ICreateLocationResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
  });

  return BaseService.Post({ url, token, data: body });
};
